import { Terminology, getTerminology } from "../../lib/terminology"
import { useSharingMinistry } from "./useSharingMinistry"

export function useTerminology(): Terminology {
  return getTerminology(useSharingMinistry())
}
